export const GET_PROFILE = "GET";
export const GET_PROFILE_CLAIMS = "GET_CLAIMS";
export const GET_PROFILE_ATTRIBUTES = "GET_PROFILE_ATTRIBUTES";
export const GET_NOTIFICATIONPREFERENCES = "GET_NOTIFICATIONPREFERENCES";
